// import 'Styles/themes/_wiski-critical.scss';

// TODO remove for prod
import 'Styles/styles.scss';

// This import will add Promise to the window.
import "promise-polyfill/src/polyfill";

// This will make events work nicely in IE11.
import "custom-event-polyfill";

// Umbraco Forms customizations.
import './components/umbraco-forms/umbraco-forms-select';
import './components/umbraco-forms/umbraco-forms-submit';

import "./lib/polyfills";
import './lib/jQuery';

import PardotCookieManager from './components/cookie/pardot-cookie-manager';

import {
    each,
    onLoad
} from './lib/util';
import HeaderComponent from './header/header';
import CardCarousel from './widgets/card-carousel/card-carousel.widget';
import ProductDetails from './widgets/product-details/product-details.widget';
import ModalComponent from './components/modal/modal';
import FAQ from './widgets/faq/faq.widget';
import HeroSlideshow from './widgets/hero-slideshow/hero-slideshow.widget';
import Subcategory from './widgets/subcategory/subcategory.widget';
import SelectComponent from './components/forms/select';
import FormComponent from './components/forms/form';
import SearchResults from './widgets/search/search-results.widget';
import ProductKit from './widgets/product-kit/product-kit.widget';
import ProductGrid from './widgets/product-grid/product-grid.widget';
import GlideCarousel from './widgets/glide-carousel/glide-carousel.widget';
import YoutubeVideoApi from './components/video/youtube-video-api';
import Banner from './widgets/banner/banner.widget';
// list of components that will fire conditionally depending on whether
// the static selector property on them matches any dom elements
const components = [
    YoutubeVideoApi,
    HeaderComponent,
    CardCarousel,
    ProductDetails,
    FAQ,
    HeroSlideshow,
    ModalComponent,
    SelectComponent,
    FormComponent,
    Subcategory,
    SearchResults,
    ProductKit,
    ProductGrid,
    GlideCarousel,
    Banner
];

if (typeof DEVELOPMENT !== 'undefined' && DEVELOPMENT) {
    window.cssLoaded = true;
}

//bootstrap

//Load youtube base component
onLoad(init);




function init() {
    var touchsupport = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
    if (touchsupport) { // browser doesn't support touch
        document.documentElement.classList.add('js-touch');
    }

    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    var isEdge = window.navigator.userAgent.indexOf("Edge") > -1;
    if (isIE11 || isEdge) {
        document.documentElement.classList.add('js-ie');
    }

    components.forEach((cmp) => {
        initComponent(cmp);
    });

    const cookieManager = new PardotCookieManager();
}

function initComponent(cmp) {
    let cmpsOnPage = cmp.getEntryElements();
    if (cmpsOnPage.length) {

        each(cmpsOnPage, (el) => {
            if (cmp.fetch && cmp.template) {
                cmp.fetch().then(data => {
                    const cmpInstance = cmp.fromTemplate(data);
                    el.parentElement.replaceChild(cmpInstance.el, el);
                }).catch(err => console.error(err));
            } else {
                new cmp(el);
            }
        })


    } else {
        return false;
    }
}
